import React, { useState, useEffect } from 'react';
import arrow from '../../assets/icons/arrow2.svg';
import arrowUp from '../../assets/icons/arrowUp.svg';
import Loader from "react-loader-spinner";
//axios
import axios from 'axios'
//constantes
import * as Constant from '../../global/const'
import auth from '../../Helpers/auth'

//Material ui
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { TransparentLoader } from '../Loader/transparentLoader.component';

var Slider = {
  position: 'absolute',
  backgroundColor: '#fff',
  border: "2px solid #0075bb",
  borderTop: 0,
  width: '-webkit-fill-available',
  right: '0%',
  zIndex: '4',
  paddingRight: '.2rem',
  height: '30vh',
  top: '39px',
  overflow: 'hidden',
  opacity: '1',
  cursor: 'auto',
  borderRadius: ' 0 0 20px 20px',
  transition: 'all 0.2s',
}

var SliderMovil = {
  position: 'absolute',
  backgroundColor: '#fff',
  border: "2px solid #0075bb",
  width: '100%',
  zIndex: '4',
  paddingRight: '.2rem',
  height: '30vh',
  top: '3rem',
  overflow: 'hidden',
  opacity: '1',
  cursor: 'auto',
  borderRadius: '20px',
  transition: 'all 0.5s',
}

var CloseSliderMovil = {
  position: 'absolute',
  backgroundColor: '#fff',
  width: '100%',
  zIndex: '4',
  paddingRight: 0,
  height: 0,
  top: '3rem',
  overflow: 'hidden',
  opacity: '1',
  cursor: 'auto',
  borderRadius: '20px',
  transition: 'all 0.5s',

}

var CloseSlider = {
  height: 0,
  border: '0px',
  zIndex: '4',
  top: '39px',
  position: 'absolute',
  backgroundColor: '#fff',
  width: '-webkit-fill-available',
  right: '0%',
  overflow: 'hidden',
  opacity: '1',
  transition: 'all 0.2s',
}

const useRowStyles = makeStyles({
});

const TableCell = withStyles({

})(MuiTableCell);

function createData(name, calories, fat, carbs, protein, price) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
    price,
    history: [
      { date: '2020-01-05', customerId: '11091700', amount: 3 },
      { date: '2020-01-02', customerId: 'Anonymous', amount: 1 },
    ],
  };
}



const PuntosVenta = () => {

  const [sucursales, setsucursales] = useState([])
  const [Allsucursales, setAllsucursales] = useState([])
  const [ciudades, setciudades] = useState([]);
  const [close, setclose] = useState(false)
  const [filter, setfilter] = useState('TODAS')

  const StyledTableRow = withStyles((theme) => ({

  }))(TableRow);

  const getSucursales = () => {
    let user = JSON.parse(auth.getUsuario())
    axios.get(Constant.GETSUCRUSALES + "?correo=" + user.email).then((response) => {
      setAllsucursales(response.data);
      setsucursales(response.data)
      getCuidades(response.data);
    }).catch((err) => {
      console.log("sucursales ", err);
    })
  }

  const Filtrar = (ciudad) => {
    if (ciudad !== 'TODAS') {
      setfilter(ciudad)
      const arraySearch = Array.from(Allsucursales)
      const results = arraySearch.filter((e) => e.ciudad === ciudad);
      setsucursales(results)
    } else {
      setfilter(ciudad)
      setsucursales(Allsucursales)
    }
    setclose(false)
  }

  const getCuidades = (All) => {
    const arraySearch = Array.from(All)
    var cuidadesAux = []
    cuidadesAux.push('TODAS')
    arraySearch.forEach((sucursal) => {
      const index = cuidadesAux.findIndex((e) => e === sucursal.ciudad);
      if (index === -1) {
        cuidadesAux.push(sucursal.ciudad);
      }
    })
    setciudades(cuidadesAux)
  }

  useEffect(() => {
    getSucursales();
    /* document.addEventListener('click', handleClickOutside, true);
    return () => {
        document.removeEventListener('click', handleClickOutside, true);
    }; */
  }, []);

  return (<>
    {sucursales.length !== 0 ?
      <div className="content-puntos">
        <div className="headerPuntos">
          <div>
            <h1>Mis puntos de venta</h1>
            <div className="sucursalesPuntos" onClick={() => setclose(!close)}>
              <h4>{filter === 'TODAS' ? 'Todas las sucursales' : `Sucursales de ${filter}`}</h4>
              <img src={arrow} alt="" />
              <div className="close desk slider-sucursales overflow-auto scrollSlider" /* ref={myRef} */ style={!close ? CloseSlider : Slider}>
                <div className="opciones ">
                  {ciudades.map((ciudad, i) => (
                    <div key={ciudad} className="opcion" onClick={() => Filtrar(ciudad)}>
                      <h6 className="no-seleccionable">{ciudad}</h6>
                    </div>
                  ))}
                </div>
              </div>
              <div className="close movil slider-sucursales overflow-auto scrollSlider" /* ref={myRef} */ style={!close ? CloseSliderMovil : SliderMovil}>
                <div className="opciones ">
                  {ciudades.map((ciudad, i) => (
                    <div key={i} className="opcion" onClick={() => Filtrar(ciudad)}>
                      <h6 className="no-seleccionable">{ciudad}</h6>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <p>Aquí encontrarás los puntos de venta registrados con nosotros, podrás ver el nombre, código, ciudad, dirección y los días de entrega de tus pedidos. También podrás darle acceso a los administradores de cada punto de venta para que realicen sus pedidos.</p>
        </div>
        <div className="bodyPuntos">
          {sucursales.length !== 0 ?
            <TableContainer component={Paper}>
              <Table className="tabla_puntos overflow-auto scrollSlider" aria-label="collapsible table">
                <TableHead className="TablaheaderPuntos">
                  <TableRow>
                    <TableCell className="titleTable">Nombre del cliente</TableCell>
                    <TableCell className="titleTable">Código cliente</TableCell>
                    <TableCell className="titleTable ciudad">Ciudad</TableCell>
                    {/* <TableCell className="titleTable" style={{ minWidth: 10 }} ></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody style={{ cursor: 'pointer' }}>
                  {sucursales.map((surcursal, i) => (
                    <Row sucursales={sucursales} key={i} row={surcursal} StyledTableRow={StyledTableRow} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            : null
          }
        </div>
        {/* <div className="bottom-datos">
        <h1>Si deseas crear un nuevo punto de venta</h1>
         <div className="btn-datos no-seleccionable">
            <h4>Crear punto de Venta</h4>
        </div>
        </div> */}
      </div>
      :
      <div className="loaderContent">
        <Loader
          type="ThreeDots"
          color="#0075bb"
          height={100}
          width={100}
        />
      </div>

    }
  </>
  )
}


function Row(props) {
  const { row, sucursales, StyledTableRow } = props;
  const [open, setOpen] = React.useState(false);
  const [error, seterror] = useState('')
  const [errorMessage, seterrorMessage] = useState('')
  const [exitoMessage, setexitoMessage] = useState('')
  const [aux, setAux] = useState(false);
  const [infoFrom, setinfoFrom] = React.useState({
    email: row.correo,
    password: ''
  });
  const [load, setLoad] = useState(false);
  const classes = useRowStyles();

  const onChange = e => {
    if (e.target.name === 'email') {
      var regexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
      if (!regexp.test(e.target.value)) {
        seterror('email')
      } else {
        seterror('')
      }
    }
    if (e.target.name === 'password') {
      var regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,15}$/
      if (!regexp.test(e.target.value)) {
        seterror('password')
      } else {
        seterror('')
      }
    }
    setinfoFrom({
      ...infoFrom,
      [e.target.name]: e.target.value
    })
  }

  const onSubmit = () => {
    if (error !== '') {
      return
    }
    setLoad(true);
    var newObject = {
      fuente: 1,
      tipo: row.tipoClienteUsuario,
      clienteUsId: row.id,
      usuario: {
        nit: row.nit,
        codigo: row.codigo,
        agencia: row.agencia
      },
      credenciales: {
        email: infoFrom.email,
        emailValidate: infoFrom.email,
        password: infoFrom.password,
        passwordValidate: infoFrom.password
      }
    }
    axios.post(Constant.UPDATEDATOS, newObject).then((response) => {
      seterrorMessage('')
      setexitoMessage(response.data.message)
      setLoad(false);
      setAux(true);
    }).catch((err) => {
      setexitoMessage('')
      if (err.response.data.errors) {
        var objkeys = Object.keys(err.response.data.errors)
        seterrorMessage(err.response.data.errors[objkeys[0]][0]);
      } else {
        seterrorMessage(err.response.data.error);
      }
      setLoad(false);
    })
  }

  useEffect(() => {
    setinfoFrom({
      email: row.correo,
      password: ''
    })
  }, [sucursales]);

  return (
    <React.Fragment>
      <StyledTableRow style={open ? { backgroundColor: "#f4f4f4" } : null} className="rowTable" onClick={() => setOpen(!open)} >
        <TableCell  >
          {/*  <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton> */}
        </TableCell>
        <TableCell className="campoTable razon" style={open ? { color: "#0075bb" } : { paddingLeft: 0 }} component="th" scope="row" >
          {row.razonsocial}
        </TableCell>

        <TableCell className="campoTable" style={open ? { color: "#0075bb" } : {}} >
          <span> </span>
          {row.codigo}
        </TableCell>

        <TableCell className="campoTable ciudad" style={open ? { color: "#0075bb" } : { minWidth: 250 }} >
          <span>Ciudad: </span>{row.ciudad}
        </TableCell>


        <TableCell style={{ minWidth: 10 }} >{!open ? <img src={arrow} alt="" /> : <img src={arrowUp} alt="" />}</TableCell>
      </StyledTableRow>
      <TableRow className="rowTableBody" style={{ display: 'flex' }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: "-webkit-fill-available", minWidth: 250 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {
              load
                ?
                <TransparentLoader />
                :
                <div className="DatosUser">
                  {errorMessage !== '' ? <span className="error">{errorMessage}</span> : null}{exitoMessage !== '' ? <span className="exito">{exitoMessage}</span> : null}
                  <div className="direcciones">
                    <h1 className="textoForm">Dirección de entrega: <span> {row.direccion}</span></h1>
                    <h1 className="textoForm">Días de entrega: <span>{row.diaEntrega}</span></h1>
                  </div>
                  <div className="userSucursal">
                    <h1 className="textoForm">Usuario sucursal:</h1>
                    <div className="campo">
                      <h1 className="textoForm">Correo electrónico:</h1>
                      <input
                        autocomplete="off"
                        name="email"
                        onChange={onChange}
                        placeholder=""
                        value={infoFrom.email}
                        type="email"
                        readOnly={(row.correo.length > 0 || aux) ? true : false}
                      />
                      {error === 'email' ? <span className="error">Formato de email invalido</span> : null}
                    </div>
                    <div className="campo">
                      <h1 className="textoForm">Contraseña:</h1>
                      <input
                        autocomplete="off"
                        name="password"
                        onChange={onChange}
                        placeholder={(row.correo.length || aux) > 0 ? "*****" : ""}
                        type="password"
                        readOnly={(row.correo.length || aux) > 0 ? true : false}
                      />
                      {error === 'password' ? <span className="error">La contraseña debe tener una mayuscula y un carácter especial @</span> : null}
                    </div>
                    <div
                      onClick={
                        () => {
                          onSubmit()
                        }
                      }
                      className={"btn-datosUser " + ((row.correo.length || aux) > 0 ? "avoid-click" : "")}
                    >
                      <h4>Guardar</h4>
                    </div>
                  </div>
                </div>
            }
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


export default PuntosVenta;